import {registerDecorator, ValidationArguments, ValidationOptions} from "class-validator";
import moment, {Moment} from "moment";

/**
 * Checks if the value is before a provided date
 */
export function IsBeforeDate(beforeDate: Date | Moment, validationOptions?: ValidationOptions) {
    return function (object: Object, propertyName: string) {
        registerDecorator({
            name: "BeforeDate",
            target: object.constructor,
            propertyName: propertyName,
            options: validationOptions,
            constraints: [beforeDate],
            validator: {
                validate(value: any, args: ValidationArguments) {
                    const [beforeDate] = args.constraints;
                    const inputDate = moment(value);
                    return inputDate.isValid() && inputDate.isBefore(moment(beforeDate));
                },
                defaultMessage(args: ValidationArguments) {
                    const [beforeDate] = args.constraints;
                    return `The date must be before ${moment(beforeDate).format("DD/MM/YYYY")}.`;
                }
            }
        });
    };
}